import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import SpecialPriceVariation from './SpecialPriceVariation';
import Image from '../../../atoms/Image';
import { MenuCategoryPropType, MenuItemPropType } from '../../../services/proptypes';
import { getCategoryItems, getCategoryNameFromItems } from '../utils';
var SpecialImage = /*#__PURE__*/function (_React$Component) {
  _inherits(SpecialImage, _React$Component);
  var _super = _createSuper(SpecialImage);
  function SpecialImage() {
    _classCallCheck(this, SpecialImage);
    return _super.apply(this, arguments);
  }
  _createClass(SpecialImage, [{
    key: "renderContent",
    value: function renderContent(item) {
      var _this$props = this.props,
        groupByCategory = _this$props.groupByCategory,
        showImage = _this$props.showImage,
        categories = _this$props.categories,
        precision = _this$props.precision;
      var name = item.name,
        _id = item._id,
        image = item.image,
        _item$gatsbyImage = item.gatsbyImage,
        gatsbyImage = _item$gatsbyImage === void 0 ? {} : _item$gatsbyImage,
        description = item.description,
        variations = item.variations;
      return /*#__PURE__*/React.createElement("div", {
        className: "special-container"
      }, showImage && /*#__PURE__*/React.createElement(Image, {
        src: gatsbyImage ? gatsbyImage.childImageSharp : image,
        className: "special-image-carousel-image",
        altText: name
      }), /*#__PURE__*/React.createElement("div", {
        className: "special-details"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "special-title"
      }, name), !groupByCategory && /*#__PURE__*/React.createElement("h4", {
        className: "special-image-category"
      }, getCategoryNameFromItems(_id, categories)), /*#__PURE__*/React.createElement("span", {
        className: "special-description"
      }, description), /*#__PURE__*/React.createElement(SpecialPriceVariation, {
        variations: variations,
        precision: precision
      })));
    }
  }, {
    key: "renderWithCategory",
    value: function renderWithCategory() {
      var _this = this;
      var _this$props2 = this.props,
        items = _this$props2.items,
        categories = _this$props2.categories;
      return /*#__PURE__*/React.createElement(Grid, {
        centered: true,
        stackable: true,
        columns: 3
      }, getCategoryItems({
        items: items,
        categories: categories
      }).map(function (_ref) {
        var name = _ref.name,
          categoryItems = _ref.items;
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: name
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          width: 16,
          textAlign: "center"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "special-category"
        }, name)), categoryItems.map(function (item) {
          return /*#__PURE__*/React.createElement(Grid.Column, {
            stretched: true
          }, _this.renderContent(item));
        }));
      }));
    }
  }, {
    key: "renderWithoutCategory",
    value: function renderWithoutCategory() {
      var _this2 = this;
      var items = this.props.items;
      return /*#__PURE__*/React.createElement(Grid, {
        centered: true,
        stackable: true,
        columns: 3
      }, items.map(function (item) {
        return /*#__PURE__*/React.createElement(Grid.Column, {
          stretched: true
        }, _this2.renderContent(item));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        groupByCategory = _this$props3.groupByCategory,
        categories = _this$props3.categories;
      return groupByCategory && categories.length ? this.renderWithCategory() : this.renderWithoutCategory();
    }
  }]);
  return SpecialImage;
}(React.Component);
SpecialImage.defaultProps = {
  categories: [],
  showImage: true,
  groupByCategory: false,
  precision: 2
};
export default SpecialImage;